import * as actions from './actions';
import { combineReducers } from 'redux';
import * as commonActions from '../actions';
import _ from 'lodash';
import { WEBSOCKET_CLOSED } from '@giantmachines/redux-websocket';

const addObjectsOrUpdateByIdInArray = (array, objects) => {
  const newArray = [...array];
  objects.forEach(obj => {
    const idx = _.findIndex(array, o => {
      return o.id === obj.id;
    });
    if (idx > -1) newArray[idx] = obj;
    else newArray.push(obj);
  });
  return newArray;
};

const threadsById = (state = {}, action) => {
  switch (action.type) {
    case actions.FETCH_INBOX_SUCCESS:
      const keyValues = {};
      action.payload.results.forEach(result => {
        keyValues[result.id] = result;
      });
      return {
        ...state,
        ...keyValues
      };
    case actions.FETCH_THREAD_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload
        }
      };

    case actions.NEW_MSG_NOTIFICATION_RECEIVED:
      return {
        ...state,
        [action.payload['notification_body'].id]: {
          ...state[action.payload['notification_body'].id],
          ...action.payload['notification_body']
        }
      };
    case actions.MARK_AS_READ_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload
      };
    default:
      return state;
  }
};

const inbox = (
  state = {
    loading: false,
    next: null,
    previous: null,
    results: []
  },
  action
) => {
  switch (action.type) {
    case actions.FETCH_INBOX_REQUEST:
      return {
        ...state,
        loading: true
      };
    case actions.FETCH_INBOX_SUCCESS:
      return {
        ...state,
        loading: false,
        next: action.payload.next,
        previous: action.payload.previous,
        // add to bottom
        results: [
          ...new Set([
            ...state.results,
            ...action.payload.results.map(result => result.id)
          ])
        ]
      };
    case actions.NEW_MSG_NOTIFICATION_RECEIVED:
      return {
        ...state,
        // add to top
        results: [
          ...new Set([action.payload['notification_body'].id, ...state.results])
        ]
      };
    case actions.FETCH_INBOX_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const threadMessages = (
  state = {
    loading: false,
    messages: {}
  },
  action
) => {
  switch (action.type) {
    case actions.FETCH_THREAD_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case actions.FETCH_THREAD_MESSAGES_SUCCESS:
      let newMessages;
      if (action.payload.results.length > 0) {
        const threadId = action.payload.results[0].thread;
        newMessages = {
          ...state.messages,
          [threadId]: {
            next: action.payload.next,
            previous: action.payload.previous,
            results: state.messages[threadId]
              ? addObjectsOrUpdateByIdInArray(
                  state.messages[threadId].results,
                  action.payload.results
                )
              : action.payload.results
          }
        };
      } else {
        newMessages = [];
      }
      return {
        ...state,
        loading: false,
        messages: newMessages
      };
    case actions.THREAD_MESSAGE_RECEIVED:
      return {
        ...state,
        messages: {
          ...state.messages,
          [action.payload.thread]: {
            ...state.messages[action.payload.thread],
            results: state.messages[action.payload.thread]
              ? [
                  action.payload,
                  ...state.messages[action.payload.thread].results
                ]
              : [action.payload]
          }
        }
      };
    case actions.FETCH_THREAD_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const dmThreadsByUserId = (state = {}, action) => {
  switch (action.type) {
    case commonActions.CREATE_DM_THREAD_SUCCESS:
      return {
        ...state,
        [action.payload.receiver_id]: action.payload.thread
      };
    default:
      return state;
  }
};

const joinedThreads = (state = {}, action) => {
  switch (action.type) {
    case actions.THREAD_JOIN_REQUEST:
      return {
        ...state,
        [action.payload.thread_id]: {
          ...state[action.payload.thread_id],
          loading: true
        }
      };
    case actions.THREAD_JOIN_SUCCESS:
      return {
        ...state,
        [action.payload.thread_id]: {
          ...state[action.payload.thread_id],
          loading: false,
          joined: true
        }
      };
    case actions.THREAD_LEAVE_REQUEST:
      return {
        ...state,
        [action.payload.thread_id]: {
          ...state[action.payload.thread_id],
          loading: true
        }
      };
    case actions.THREAD_LEAVE_SUCCESS:
      return _.omit(state, action.payload.thread_id);
    case WEBSOCKET_CLOSED:
      return {};
    default:
      return state;
  }
};

export default combineReducers({
  threads: inbox,
  threadsById,
  joinedThreads,
  threadMessages: threadMessages,
  dmThreadsByUserId: dmThreadsByUserId
});
